function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import VirtualScroller from './VirtualScroller';
import log from './log';
import { px } from './utility';

var DOMVirtualScroller =
/*#__PURE__*/
function () {
  function DOMVirtualScroller(element, _items, renderItem) {
    var _this = this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, DOMVirtualScroller);

    _defineProperty(this, "onStateChange", function (state, prevState) {
      var items = state.items,
          firstShownItemIndex = state.firstShownItemIndex,
          lastShownItemIndex = state.lastShownItemIndex,
          beforeItemsHeight = state.beforeItemsHeight,
          afterItemsHeight = state.afterItemsHeight;
      log('~ On state change ~');
      log('Previous state', prevState);
      log('New state', state); // Set container padding top and bottom.

      _this.container.style.paddingTop = px(beforeItemsHeight);
      _this.container.style.paddingBottom = px(afterItemsHeight); // Perform an intelligent "diff" re-render if the `items` are the same.

      var diffRender = prevState && items === prevState.items && prevState.items.length > 0; // Remove no longer visible items from the DOM.

      if (diffRender) {
        log('Incremental render'); // Decrement instead of increment here because
        // `this.container.removeChild()` changes indexes.

        var _i = prevState.lastShownItemIndex;

        while (_i >= prevState.firstShownItemIndex) {
          if (_i >= firstShownItemIndex && _i <= lastShownItemIndex) {// The item is still being shown.
          } else {
            log('Remove item', _i); // The item is no longer visible so remove it from the DOM.

            var item = _this.container.childNodes[_i - prevState.firstShownItemIndex];

            _this.container.removeChild(item);
          }

          _i--;
        }
      } else {
        log('Clean render');

        while (_this.container.firstChild) {
          _this.container.removeChild(_this.container.firstChild);
        }
      } // Add newly visible items to the DOM.


      var shouldPrependItems = diffRender;
      var prependBeforeItemElement = shouldPrependItems && _this.container.firstChild;
      var i = firstShownItemIndex;

      while (i <= lastShownItemIndex) {
        if (diffRender && i >= prevState.firstShownItemIndex && i <= prevState.lastShownItemIndex) {
          // The item is already shown, so don't re-render it.
          // Next new items will be appended rather than prepended.
          if (shouldPrependItems) {
            shouldPrependItems = false;
          }
        } else {
          var _item = _this.renderItem(items[i]);

          if (shouldPrependItems) {
            log('Prepend item', i); // Append `item` to `this.container` before the retained items.

            _this.container.insertBefore(_item, prependBeforeItemElement);
          } else {
            log('Append item', i); // Append `item` to `this.container`.

            _this.container.appendChild(_item);
          }
        }

        i++;
      }
    });

    _defineProperty(this, "onUnmount", function () {
      _this.virtualScroller.onUnmount();
    });

    this.container = element;
    this.renderItem = renderItem;

    var onMount = options.onMount,
        restOptions = _objectWithoutProperties(options, ["onMount"]);

    this.virtualScroller = new VirtualScroller(function () {
      return _this.container;
    }, _items, _objectSpread({}, restOptions, {
      onStateChange: this.onStateChange
    }));

    if (onMount) {
      onMount();
    }

    this.virtualScroller.onMount();
  }

  _createClass(DOMVirtualScroller, [{
    key: "onItemHeightChange",
    value: function onItemHeightChange(i) {
      this.virtualScroller.onItemHeightChange(i);
    }
    /**
     * @deprecated
     * `.updateItems()` has been renamed to `.setItems()`.
     */

  }, {
    key: "updateItems",
    value: function updateItems(newItems, options) {
      this.setItems(newItems, options);
    }
  }, {
    key: "setItems",
    value: function setItems(newItems, options) {
      this.virtualScroller.setItems(newItems, options);
    }
  }, {
    key: "getItemCoordinates",
    value: function getItemCoordinates(i) {
      return this.virtualScroller.getItemCoordinates(i);
    }
  }]);

  return DOMVirtualScroller;
}();

export { DOMVirtualScroller as default };
//# sourceMappingURL=DOMVirtualScroller.js.map